import { ataService } from '@/services/ata/ata-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { models } from 'cesg-shared';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useAtaTableInvoicingOkData = (
  projectId: MaybeRefOrGetter<string>,
) => {
  return useQuery({
    queryKey: computed(() =>
      projectKeys.ata({ projectId: toValue(projectId), status: models.domain.AtaStatusType.InvoicingOk }),
    ),
    queryFn: () =>
      ataService.getAtasWithCost(toValue(projectId), {
        status: models.domain.AtaStatusType.InvoicingOk,
      }),
    enabled: computed(() => !!toValue(projectId)),
  });
};
